export function isParticipantFacingRoute(route) {
  if (!route) {
    return false;
  }

  const name = String(route.name ?? '');

  if (name.startsWith('theme-admin')) {
    return false;
  }

  if (name.startsWith('theme-participant')) {
    return true;
  }

  const path = route.path ?? '';

  return path.includes('/participant/');
}

export function isParticipantTaskRoute(route) {
  if (!route) {
    return false;
  }

  const name = String(route.name ?? '');

  return name.startsWith('theme-participant-task');
}
